import React from 'react'

interface IProps {
    children: React.ReactNode;
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
    showDetails: boolean;
}

const SlidedScreen = (props: IProps) => {
    const { children, onClick, showDetails } = props;
    return (
        <>
            {showDetails && <div className='fixed inset-0 bg-black bg-opacity-50 lg:hidden z-40 blur-sm'></div>}
            <div
                className={`fixed inset-y-0 right-0 w-full md:w-[80%] bg-[#343434] rounded-lg p-2 z-50 
                        transition-transform duration-300 ease-in-out 
                        ${showDetails ? "translate-x-0" : "translate-x-full"} xl:hidden block`}
            >
                <div className='pt-2 pb-5 px-3'>
                    <button
                        onClick={onClick}
                        className=" text-white rounded-md text-lg font-bold self-end mb-4 float-end"
                    >
                        ✖
                    </button>
                </div>
                {children}
            </div>
        </>
    )
}

export default SlidedScreen